import React from 'react';
import {useFormik, FormikContext} from "formik";
import Title from '../../../../../@casino/ui/title';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { setGetFreespin } from '../../store/thunk/setGetFreespin';
import { useDispatch } from 'react-redux';
import { setPostCanceled } from '../../store/thunk/setPostCanceled';

const useStyles = makeStyles(() => ({
    flex: {
        display: 'flex',
        width: '100%'
    },
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    helper2: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '14px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
        width: '100%'
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '100%', 
    },
}))


const ViewFreespin = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [codes, setCode] = React.useState('');
 
    const initialValues = {
        freespin_id: ''
    }

    const onSubmit = (store) => {
        dispatch(setGetFreespin({
            freespin_id: store.freespin_id
        }, setCode))
    }

    const formik = useFormik({onSubmit, initialValues});
    const code = codes && JSON.parse(codes);

    return (
        <div style={{padding: '0 20px'}}>
            <Title label="Информация о спине"/>
            <div style={{
                argin: '12px 0',
                display: 'flex',
                padding: '20px',
                background: '#1b2039',
                alignItems: 'center',
                borderRadius: '8px'
            }}>
                <FormikContext.Provider value={formik}>
                    <form 
                        onSubmit={formik.handleSubmit}
                    >
                        <div className={classes.flex}>
                            <label htmlFor="freespin_id" className={clsx(classes.wrapLabel, classes.beginBonusLabel)} style={{width: 500}}>
                                <span className={classes.helper}>Freespin id</span>
                                <input 
                                    type="text" 
                                    name="freespin_id" 
                                    id="freespin_id" 
                                    className={classes.text} 
                                    value={formik.values.freespin_id} 
                                    onChange={(v) => formik.setFieldValue('freespin_id', v.target.value)}/>
                            </label>
                            <div style={{display: 'flex', alignItems: 'center', marginLeft: 20}}>  
                                <span style={{
                                        color: 'rgb(36, 38, 62)',
                                        border: '1px solid rgb(255, 206, 1)',
                                        background: 'rgb(255, 206, 1)',
                                        cursor: 'pointer',
                                        padding: '5px 10px',
                                        overflow: 'hidden',
                                        fontSize: '14px',
                                        maxHeight: '48px',
                                        fontFamily: 'PT Sans, sans-serif',
                                        fontWeight: 400,
                                        userSelect: 'none',
                                        whiteSpace: 'nowrap',
                                        marginRight: '12px',
                                        borderRadius: '16px',
                                        textOverflow: 'ellipsis',
                                        textTransform: 'uppercase',
                                    }}
                                    onClick={() => formik.submitForm()}
                                >Проверить</span>
                            </div>
                        </div>  
                        {
                            code && (
                                <div>
                                    <div>
                                        <span className={classes.helper2}>Player ID:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.player_id}</span>
                                    </div>
                                    <div>
                                        <span className={classes.helper2}>Currency:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.currency}</span>
                                    </div> 
                                    <div>
                                        <span className={classes.helper2}>Quantity:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.quantity}</span>
                                    </div> 
                                    <div>
                                        <span className={classes.helper2}>Quantity Left:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.quantity_left}</span>
                                    </div> 
                                    <div>
                                        <span className={classes.helper2}>Valid From:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.valid_from}</span>
                                    </div> 
                                    <div>
                                        <span className={classes.helper2}>Valid Until:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.valid_until}</span>
                                    </div> 
                                    <div>
                                        <span className={classes.helper2}>Freespin ID:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.freespin_id}</span>
                                    </div> 
                                    <div>
                                        <span className={classes.helper2}>Freespin UUID:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.freespin_uuid}</span>
                                    </div> 
                                    <div>
                                        <span className={classes.helper2}>BET ID:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.bet_id}</span>
                                    </div>
                                    <div>
                                        <span className={classes.helper2}>denomination:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.denomination}</span>
                                    </div> 
                                    <div>
                                        <span className={classes.helper2}>Game UUID:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.game_uuid}</span>
                                    </div> 
                                    <div>
                                        <span className={classes.helper2}>Status:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.status}</span>
                                    </div>
                                    <div>
                                        <span className={classes.helper2}>Is canceled:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.is_canceled}</span>
                                    </div> 
                                    <div>
                                        <span className={classes.helper2}>Total win:</span>&nbsp;
                                        <span className={classes.helper2}>{code?.total_win}</span>
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'center'}}>  
                                        <span style={{
                                                color: 'rgb(36, 38, 62)',
                                                border: '1px solid rgb(255, 206, 1)',
                                                background: 'rgb(255, 206, 1)',
                                                cursor: 'pointer',
                                                padding: '5px 10px',
                                                overflow: 'hidden',
                                                fontSize: '14px',
                                                maxHeight: '48px',
                                                fontFamily: 'PT Sans, sans-serif',
                                                fontWeight: 400,
                                                userSelect: 'none',
                                                whiteSpace: 'nowrap',
                                                borderRadius: '16px',
                                                textOverflow: 'ellipsis',
                                                textTransform: 'uppercase',
                                            }}
                                            onClick={() => dispatch(setPostCanceled({freespin_id: code?.freespin_id, user_id: code?.player_id}, setCode))}
                                        >Отменить</span>
                                    </div>
                                </div>
                            )
                        }
                    </form>
                </FormikContext.Provider>
            </div>
        </div>
    )
}

export default ViewFreespin;